import { create } from "zustand";

const UseTarifsSecondColor = create((set) => ({
  color: "#535455",
  setColor: (color) => set({ color: color }),
}));

export default UseTarifsSecondColor;
